import React, {useEffect, useState, memo} from 'react';


function roundScore(score) {
	switch (true) {
		case score <= 95:
			return score;

		case score > 95 && score <= 150:
			return 96;

		case score > 150 && score <= 250:
			return 97;

		case score > 250 && score <= 350:
			return 98;

		case score > 350:
			return 99;

		default:
			return score;
	}
}
function renderScore(score) {
	let color;
	let text;
	switch (true) {
		case !score || score < 60:
			color = '#F44336';
			text = 'F';
			break;
		case score >= 60 && score < 66:
			color = '#FF9800';
			text = 'D';
			break;
		case score >= 66 && score < 70:
			color = '#FF9800';
			text = 'D+';
			break;
		case score >= 70 && score < 76:
			color = '#FFEB3B';
			text = 'C';
			break;
		case score >= 76 && score < 80:
			color = '#FFEB3B';
			text = 'C+';
			break;
		case score >= 80 && score < 86:
			color = '#2196F3';
			text = 'B';
			break;
		case score >= 86 && score < 90:
			color = '#2196F3';
			text = 'B+';
			break;
		case score >= 90 && score < 96:
			color = '#4CAF50';
			text = 'A';
			break;
		case score >= 96:
			color = '#4CAF50';
			text = 'A+';
			break;
		default:
			color = '#000';
			text = 'N/A'; // fallback case
	}

	return <b style={{color: color, fontSize: 36, lineHeight: 'normal'}}>
		{text}
	</b>
}
const Ticket_Score_Breakdown = memo((props) => {
	const explanation_keys = [
		['total_score', 'Overall Ticket Score'],
		['av_score', 'Anti Virus Score', 'av_chars', 'av_images'],
		['backup_score', 'Backup Score', 'backup_chars', 'backup_images'],
		['network_score', 'Network Score', 'network_chars', 'network_images'],
		['hdd_score', 'HDD Score', 'hdd_chars', "hdd_images"],
		['notes_score', 'Notes Score', 'notes_chars', 'notes_images'],
		['time_score', 'Time Score', 'time_value']
	]
	const [scores, setScores] = useState({});
	useEffect(() => {
		setScores(props.scores)
	}, [])

	return (
		<div style={{display: 'flex', flexDirection: 'column'}}>
			<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
				{scores.total_score ? explanation_keys.map((key_array, i) => {
					// Render the first item in its own row
					if (i === 0) {
						return (
							<div key={i + Math.random()}
							     style={{justifyContent: 'center', alignItems: 'center', width: '100%', flexDirection: 'column', display: 'flex'}}>
								<div style={{
									height: 40, // Reduced height
									backgroundColor: '#3D3D3D',
									alignItems: 'center',
									display: 'flex'
								}}>
									<b style={{
										width: '100%',
										fontSize: 24, // Adjusted for a smaller size
										color: 'white',
										textAlign: 'center',
									}}>
										{key_array[1]}: {roundScore(scores[key_array[0]])}
									</b>
								</div>
								{renderScore(scores[key_array[0]])}
							</div>
						)
					}
				}) : <b>This score has not been generated yet... Check back later.</b>}

				{/* Render the remaining items two per row */}
				<div style={{flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', width: '100%', display: 'flex'}}>
					{scores.total_score ? explanation_keys.map((key_array, i) => {
						if (i > 0) {
							return (
								<div key={i + Math.random()}
								     style={{
									     justifyContent: 'center',
									     alignItems: 'center',
									     width: '45%',
									     marginVertical: 5,
									     display: 'flex',
									     flexDirection: 'column'
								     }}>
									<div style={{
										height: 40, // Reduced height
										backgroundColor: '#3D3D3D',
										alignItems: 'center',
										display: 'flex',
										width: '100%'
									}}>
										<b style={{
											width: '100%',
											fontSize: 24, // Adjusted for a smaller size
											color: 'white',
											textAlign: 'center',
										}}>
											{key_array[1]}: {roundScore(scores[key_array[0]])}
										</b>
									</div>
									<div style={{justifyContent: 'space-between', flexDirection: 'row', width: '90%', display: 'flex'}}>
										{renderScore(scores[key_array[0]])}
										<div style={{flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
											{!scores[key_array[2]] ? <>
													<b>Characters: N/A</b>
													<b>Step Waived</b>
												</> :
												<>
													<b>{i !== 6 ? 'Characters: ' : 'Minutes on Site: '}{scores[key_array[2]]}</b>
													{i !== 6 && <b>Images Taken: {scores[key_array[3]]}</b>}
												</>}
										</div>
									</div>
								</div>
							)
						}
					}) : <b>This should take no more than 10 minutes.</b>}
				</div>
			</div>
			<br/>
			<b style={{marginLeft: 5, paddingVertical: 5}}>*Total Score Calculation: (((AV Score + Backup Score + Network Score + HDD Score + Generic
				Notes Score) / 5) + Time Score) / 2</b>
			<br/>
			<b style={{marginLeft: 5, paddingVertical: 5}}>*Page Component Score Calculation: Characters on Page + Images (315 Characters = B)</b>
			<br/>
			<b style={{marginLeft: 5, paddingVertical: 5}}>*Time Score Calculation: .77 points / minute (1.75 Hours = B)</b>

		</div>
	)
})

export default Ticket_Score_Breakdown;



